import React, { useState } from 'react';
import Headline from 'headline';
import Button from 'button';
import Input from 'shared/form-input';
import Icon from 'icon';
import axios from 'axios';
import { useFormInput, useErrors, useSubmitReady } from 'hooks/useForm';
import s from './suggest-infl.module.scss';

export default function SuggestInfl({ ...props }) {
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inDatabase, setInDataBase] = useState(false);
  const [connectionError, setConnectionError] = useState(false);
  const username = useFormInput('');
  const usernameErrors = useErrors({ username: username.state });
  const resetForm = () => {
    username.setters.setBlurred(false);
    username.setters.setTouched(false);
    username.setters.setValue('');
  };
  const submitReady = useSubmitReady({
    username: username.state
  });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setInDataBase(false);
    const payload = {
      username: username.state.value,
      date: new Date().toDateString(),
      page: window.location.pathname
    };
    try {
      const res = await axios.post(
        // 'http://localhost:5000/furlough-main/us-central1/createInfluencers',
        'https://us-central1-furlough-main.cloudfunctions.net/createInfluencers',
        payload
      );
      if (res.data === 'This influencer is already in the database') {
        setInDataBase(true);
        setLoading(false);
      } else if (res.data === 'Some fields are blank') {
        setConnectionError(true);
        setTimeout(() => setConnectionError(false), 10000);
        setLoading(false);
      } else {
        setSuccess(true);
        setTimeout(() => setSuccess(false), 5000);
        setLoading(false);
        resetForm();
      }
      console.log(res);
    } catch (error) {
      console.log('error', error);
      setConnectionError(true);
      setTimeout(() => setConnectionError(false), 10000);
      setLoading(false);
    }
  };

  const buttonContent = () => {
    if (loading) {
      return (
        <span className={s.spinner}>
          <Icon icon="spinner" className="animate-spin" />
        </span>
      );
    }
    if (success) return 'Success!';
    return 'Submit';
  };

  return (
    <div className={s.root}>
      <Headline title h2>
        Suggest Influencers
      </Headline>
      <p>
        Want us to feature or audit an influencer's audience? Suggest them here:
      </p>
      <form className={s.form} onSubmit={handleSubmit}>
        <Input
          {...username.events}
          error={usernameErrors.username}
          className={s.input}
          required
          placeholder="Enter Influencer @Username"
          type="text"
          dark
          value={username.state.value}
        />
        <Button className={s.button} disabled={!submitReady} type="submit">
          {buttonContent()}
        </Button>
        {connectionError && (
          <p className={`error ${s.message}`}>
            There was an error processing your request, please try again in a
            few minutes and check that the influencer's username is written
            properly.
          </p>
        )}
        {inDatabase && (
          <p className={s.message}>
            This influencer is already being featured or audited.
            {' '}
            <a href={`/influencers/${username.state.value.replace('@', '')}`}>
              Click here
            </a>
            {' '}
            to go to its page.
          </p>
        )}
        {success && (
          <p className={s.message}>Your submission has been processed.</p>
        )}
      </form>
    </div>
  );
}
